import { useCallback } from "react";

import { useResetAtom } from "jotai/utils";

import {
  changedCellsAtom,
  columnFiltersAtom,
  columnWidthsAtom,
  fieldGroupDataAtom,
  modalStateAtom
} from "../atoms/fieldGroupAtoms";

/**
 * Hook that handles resetting all field group editor state.
 */
export function useFieldGroupReset() {
  const resetChangedCells = useResetAtom(changedCellsAtom);
  const resetModalState = useResetAtom(modalStateAtom);
  const resetColumnWidths = useResetAtom(columnWidthsAtom);
  const resetColumnFilters = useResetAtom(columnFiltersAtom);
  const resetFieldGroupData = useResetAtom(fieldGroupDataAtom);

  const resetAllState = useCallback(() => {
    resetChangedCells();
    resetModalState();
    resetColumnWidths();
    resetColumnFilters();
    resetFieldGroupData();
  }, [
    resetChangedCells,
    resetModalState,
    resetColumnWidths,
    resetColumnFilters,
    resetFieldGroupData
  ]);

  return {
    resetAllState
  };
}
